import { defineComponent } from "vue";

import { PalServiceLocations } from "../../../../../../../enums/PalServiceLocationsEnum";
import { formatDate } from "../../../../../../../common/vue-helpers/modifiers/value-modifier";

import TablePrompt from "../../../../../../../resources-vue/vue-custom-elements/TablePrompt/TablePrompt.vue";
import EmptyTextHandler from "../../../../../../../resources-vue/vue-custom-elements/EmptyTextHandler/EmptyTextHandler.vue";
import PreadmissionNotesForm from "../PreadmissionNotesForm/PreadmissionNotesForm.vue";

export default defineComponent({
    components: {
        TablePrompt,
        EmptyTextHandler,
        PreadmissionNotesForm
    },
    props: {
        resetList: {
            type: Function
        },
        columns: {
            type: Number
        },
        patientDetails: {
            type: Object
        },
        note: {
            type: Object
        },
        application: {
            type: Number
        },
        accountId: {
            type: String
        },
        patientId: {
            type: String
        }
    },

    data(vm) {
        return {
            isViewRequested: false,
            PalServiceLocationsEnum: PalServiceLocations,
            formatDate
        };
    },

    methods: {
        openViewNote() {
            this.isViewRequested = true;
        },
        closeViewNote() {
            this.isViewRequested = false;
        }
    }
});
